import axios from 'axios';
import { Constants } from 'utils';

export const Api = axios.create({
    baseURL: Constants.BASE_URL,
    withCredentials: true
});

const RefreshApi = axios.create({
    baseURL: Constants.BASE_URL,
    withCredentials: true
});

const NO_REFRESH_PATHS = ['/auth', '/auth/refresh', '/auth/logout'];

let refreshPromise = null;
let authFailureHandler = null;
let authFailurePromise = null;

const normalizeUrl = (url = '') => url.split('?')[0];

const isNoRefreshPath = (url) => {
    const normalizedUrl = normalizeUrl(url);
    return NO_REFRESH_PATHS.some((path) => normalizedUrl === path || normalizedUrl.endsWith(path));
};

export const setAuthFailureHandler = (handler) => {
    authFailureHandler = typeof handler === 'function' ? handler : null;
};

const notifyAuthFailure = async () => {
    if (!authFailureHandler) {
        return;
    }

    if (!authFailurePromise) {
        authFailurePromise = Promise.resolve()
            .then(() => authFailureHandler())
            .catch(() => {})
            .finally(() => {
                authFailurePromise = null;
            });
    }

    await authFailurePromise;
};

export const requestRefresh = async () => {
    if (!refreshPromise) {
        refreshPromise = RefreshApi.post('/auth/refresh')
            .then(() => true)
            .catch(() => false)
            .finally(() => {
                refreshPromise = null;
            });
    }

    return refreshPromise;
};

Api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error?.config;
        const status = error?.response?.status;
        const url = originalRequest?.url || '';

        if (!originalRequest || status !== 401) {
            return Promise.reject(error);
        }

        if (originalRequest._retry || isNoRefreshPath(url)) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        const refreshResult = await requestRefresh();
        if (!refreshResult) {
            await notifyAuthFailure();
            return Promise.reject(error);
        }

        return Api(originalRequest);
    }
);
